import webBiLogger from '@wix/web-bi-logger';
import { useCallback } from 'react';

import { LogBI } from '../types';
import { useSessionBI } from './useSessionBI';
import {
  getClientIdOrGenerate,
  hasWixClientId,
  setWixClientId,
} from '../utils/login';
import { useStore } from '../zustand/stores';

export const useBI = () => {
  const { getSessionBI } = useSessionBI();
  const { loggedInAccountId } = useStore((state) => state.userSlice);
  const sendBIEvent = useCallback(
    async (event: LogBI): Promise<void> => {
      if (!hasWixClientId()) {
        setWixClientId();
      }

      const biLogger = webBiLogger
        .factory()
        .withNonEssentialContext({
          clientId: getClientIdOrGenerate(),
        })
        .logger();
      getSessionBI(event)
        .then(async (value) => {
          if (value) {
            event.params.self_service_session_id = value;
          }
          if (loggedInAccountId) {
            event.params.target_account_id = loggedInAccountId;
          }
          await biLogger.report(event);
        })
        .catch(() => biLogger.report(event));
    },
    [getSessionBI, loggedInAccountId]
  );

  return { sendBIEvent };
};
